import { connect }             from 'react-redux';
import PlaceList               from '../components/PlaceList';
import { hydrateFilter }       from './../actions/FilterAction';

const mapStateToProps = (state) => {
    return {
        geo      : state.geo,
        hasGoogle: state.appHeader.google,
        filter   : state.filter.selected,
        places   : hydrateFilter(state.filter.selected, state.places.items),
        viewType : state.view.placesView,
        theme    : state.assets.items.theme
    }
};

const PlaceListContainer = connect(mapStateToProps)(PlaceList);

export default PlaceListContainer;


// WEBPACK FOOTER //
// ./src/containers/PlaceListContainer.js